import { lazy } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { AdminRoute, Route } from '@client/components/common/Route';

const ShowsLoader = lazy(() => import('@client/components/routes/Shows'));
const ShowsDetailsLoader = lazy(() => import('@client/components/routes/Shows/Details'));
const ShowsEditLoader = lazy(() => import('./Shows/Edit'));

export default () => (
  <Switch>
    <Route
      path="/shows"
      exact
      load={ShowsLoader}
    />

    <Route
      path="/shows/:showId"
      exact
      load={ShowsDetailsLoader}
    />

    <Redirect
      exact
      path={['/shows/:showId/door/', '/shows/:showId/guestlist']}
      to="/myshows/:showId/audience/"
    />

    <Route
      path="/shows/:showId/tickets"
      exact
      load={ShowsDetailsLoader}
      ComponentProps={{ showBrowseTicketsOnLoad: true }}
    />

    <AdminRoute
      path="/shows/:showId/edit"
      exact
      load={ShowsEditLoader}
    />

    <AdminRoute
      path="/shows/:showId/withTicket"
      exact
      load={ShowsDetailsLoader}
    />

    <AdminRoute
      path="/shows/:showId/withoutTicket"
      exact
      load={ShowsDetailsLoader}
    />
  </Switch>
);
